import { IEntity } from '@opengov/api-deprecated';

import { composeEffects } from '../../module';

import { CurrentOrLegacySavedView } from '../records/currentOrLegacySavedView';
import { currentOrLegacySavedViewActionCreators } from '../state';
import { getCurrentOrLegacySavedViews } from '@opengov/reporting-legacy-module';

const { loadSavedViewsError, loadSavedViewsSuccess } = currentOrLegacySavedViewActionCreators;

export const currentOrLegacySavedViewEffects = composeEffects('savedViews', (compose) => ({
  loadSavedViewsForReport: compose.effect(
    async (e: { reportId?: string; legacyReportId?: string; reportVersion: string; entity?: IEntity }) => {
      currentOrLegacySavedViewActionCreators.loadSavedViews();
      try {
        const savedViews = (await getCurrentOrLegacySavedViews(e)).map(CurrentOrLegacySavedView);
        loadSavedViewsSuccess(savedViews);
        return savedViews;
      } catch (error) {
        loadSavedViewsError(error);
      }
    }
  )
}));
